// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"139":"adminbau-vue","271":"adminbau-chat","678":"adminbau-activity"}[chunkId] + "-min.js";
};